<template>
    <div>
        <h1 class="screen-title">{{ $t('statistics') }}</h1>

        <div v-if="stats" class="stat-grid">
            <div class="stat-tile">
                <div class="stat-value">{{ stats.total_visits }}</div>
                <div class="stat-label">{{ $t('totalVisits') }}</div>
            </div>
            <div class="stat-tile">
                <div class="stat-value">{{ stats.visits_this_month }}</div>
                <div class="stat-label">{{ $t('visitsThisMonth') }}</div>
            </div>
            <div class="stat-tile">
                <div class="stat-value">{{ stats.visits_this_year }}</div>
                <div class="stat-label">{{ $t('visitsThisYear') }}</div>
            </div>
        </div>

        <div v-if="stats && stats.products.length > 0" class="card">
            <div class="card-title">{{ $t('productsUsed') }}</div>
            <div class="stat-products">
                <div v-for="(product, key) in stats.products" :key="key" class="stat-products-row">
                    <span class="stat-products-name">{{ product.product_name }}</span>
                    <span class="stat-products-qty">{{ product.quantity_display }}</span>
                </div>
            </div>
        </div>

        <div class="day-heading">{{ $t('myVisits') }}</div>

        <div v-if="loaded && visits.length === 0" class="empty-state">
            <i class="fa-regular fa-calendar-xmark"></i>
            {{ $t('noVisits') }}
        </div>

        <div v-for="visit in visits" :key="visit.id" class="visit-item">
            <div class="visit-item-head">
                <span class="visit-item-date">{{ formatDate(visit.checked_in_at) }}</span>
                <span class="visit-item-time">{{ formatTimeRange(visit) }}</span>
            </div>
            <div v-if="visit.products.length > 0" class="visit-item-products">
                <span v-for="(product, key) in visit.products" :key="key" class="visit-chip">
                    {{ product.product_name }} <span class="visit-chip-qty">×{{ product.quantity_display }}</span>
                </span>
            </div>
        </div>

        <button v-if="visits.length < total" class="btn btn-ghost btn-block visits-load-more" @click="loadMore">
            <i class="fa-solid fa-chevron-down"></i> {{ $t('loadMore') }}
        </button>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'StatisticsView',
    data() {
        return {
            stats: null,
            visits: [],
            page: 1,
            total: 0,
            loaded: false
        };
    },
    mounted() {
        this.loadStats();
        this.loadVisits();
    },
    methods: {
        async loadStats() {
            const response = await this.$api.get('visits/statistics');
            if (response.success) {
                this.stats = response.data;
            }
        },
        async loadVisits() {
            const response = await this.$api.get('visits', { page: this.page });
            if (response.success) {
                this.visits = this.visits.concat(response.data.records);
                this.total = response.data.total_records;
            }
            this.loaded = true;
        },
        loadMore() {
            this.page++;
            this.loadVisits();
        },
        formatDate(datetime) {
            return moment(datetime, 'YYYY-MM-DD HH:mm:ss').locale(this.$store.state.language).format('dddd, D.M.YYYY.');
        },
        // "08:15 – 09:30" once checked out, or "08:15 – …" while the visit is still open.
        formatTimeRange(visit) {
            const inTime = moment(visit.checked_in_at, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
            if (!visit.checked_out_at) return inTime + ' – …';
            const outTime = moment(visit.checked_out_at, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
            return inTime + ' – ' + outTime;
        }
    }
};
</script>
